<template>
    <v-group>
        <v-line
                ref="drag_rect"
                @dragstart="rectDragStart"
                @dragmove="rectDragMove"
                @dragend="rectDragEnd"
                @tap="() => {}"
                :config="{points: [tl.x, tl.y, tr.x, tr.y, br.x, br.y, bl.x, bl.y], closed: true, draggable: true}"
        ></v-line>
        <v-group>
            <v-line :config="{points: [tl.x, tl.y, tr.x, tr.y], ...line_config}"></v-line>
            <v-line :config="{points: [tr.x, tr.y, br.x, br.y], ...line_config}"></v-line>
            <v-line :config="{points: [br.x, br.y, bl.x, bl.y], ...line_config}"></v-line>
            <v-line :config="{points: [bl.x, bl.y, tl.x, tl.y], ...line_config}"></v-line>
        </v-group>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('top_left', e)" @dragend="dragEnd"     :config="{x: tl.x, y: tl.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('top_right', e)" @dragend="dragEnd"    :config="{x: tr.x, y: tr.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('bottom_left', e)" @dragend="dragEnd"  :config="{x: bl.x, y: bl.y, ...circle_config}"></v-circle>
        <v-circle @dragstart="$emit('move_start')" @dragmove="e => drag('bottom_right', e)" @dragend="dragEnd" :config="{x: br.x, y: br.y, ...circle_config}"></v-circle>
    </v-group>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import CONST from '../../../assets/js/const'
    import {loadImage} from '../../../assets/js/loadImageByPromise'
    const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST;

    export default {
        name: "EditRectDefault",
        props: ["default_item"],
        data() {
            return {
                EDIT_CIRCLE_RADIUS,
                EDIT_RECT_SIZE,

                is_showing_option_menu: false,
                delete_obj: {},
                add_obj: {},
                font_obj: {fontFamily: '"Yu Gothic UI", "游ゴシック体", YuGothic, "游ゴシック Medium", "Yu Gothic Medium", "游ゴシック", "Yu Gothic", sans-serif'},

                //選択範囲ドラッグ時に使用 移動開始時の座標を保持する
                position_temp: {
                    x: 0, y: 0,
                    top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                    top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                    bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                    bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
                },

                top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
                top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
                bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
                bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
            }
        },
        computed: {
            ...mapState(['current_image', 'edit_mode', 'rect_width', 'is_check_pattern', 'is_curtain', 'input_scale', 'konva_stage']),
            ...mapState('simulator', ['editing_id', 'is_operating']),
            ...mapGetters('simulator', ['editing_item']),

            circle_config: _this => ({radius: EDIT_CIRCLE_RADIUS, fill: _this.editing_id === _this.default_item.id ? '#eac42b' : '#fff', draggable: true, opacity: 0.5}),
            line_config: _this => ({stroke: _this.editing_id === _this.default_item.id ? '#eac42b' : '#fff', strokeWidth: 7, opacity: 0.7}),

            tl: _this => ({x: _this.top_left.x * _this.input_scale,     y: _this.top_left.y * _this.input_scale}),
            tr: _this => ({x: _this.top_right.x * _this.input_scale,    y: _this.top_right.y * _this.input_scale}),
            bl: _this => ({x: _this.bottom_left.x * _this.input_scale,  y: _this.bottom_left.y * _this.input_scale}),
            br: _this => ({x: _this.bottom_right.x * _this.input_scale, y: _this.bottom_right.y * _this.input_scale}),
        },
        created() {
            const item = this.default_item;
            if (!item) { this.initArea(); return;}
            const { points } = item;
            if (points) Object.keys(points).forEach( s => this[s] = points[s] );
            else this.initArea();
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations("simulator", ["updateItem", "setIsOperating", "setIsContinuingLoading", "createTempItem", "updateTempItem"]),
            ...mapActions("simulator", ["removeItemData", "updateItemInfo", "commitTempItem"]),
            ...mapActions(["resetTimer"]),

            deleteCurtain() {
                this.removeItemData(this.editing_id);
            },
            async setPosition(points) {
                // const calculated_points = Util.calculatePoint(points);
                this.updateTempItem({points: points});

                await this.commitTempItem();
                this.resetTimer();
                this.setModal('');
            },
            async image_config(func_name) {
                const img_obj = await loadImage(`${CONST.BASE_URL}assets/images/active_borders_${func_name}.png`);
                return {image: img_obj};
            },
            drag(point, e) {
                this[point] = {
                    x: e.target.x() * (1 / this.input_scale),
                    y: e.target.y() * (1 / this.input_scale)
                };
                this.$emit('move');
            },
            dragEnd() {
                this.emitPointsInfo();
            },
            rectDragStart(e) {
                const { top_left, top_right, bottom_left, bottom_right } = this;
                this.position_temp = {
                    x: e.target.x(), y: e.target.y(),
                    points: { top_left, top_right, bottom_left, bottom_right }
                };
                this.$emit('move_start');
            },
            rectDragMove(e) {
                const {x, y, points} = this.position_temp;

                const move_x = (x - e.target.x()) * (1 / this.input_scale);
                const move_y = (y - e.target.y()) * (1 / this.input_scale);
                ['top_left', 'top_right', 'bottom_left', 'bottom_right'].forEach(point => {
                    this[point] = {x: points[point].x - move_x, y: points[point].y - move_y}
                });
                this.$emit('move');
            },
            rectDragEnd() {
                const drag_rect = this.$refs.drag_rect.getNode();
                drag_rect.x(0);
                drag_rect.y(0);
                this.emitPointsInfo();
                //drag_rect.x(n)、drag_rect.y(n)でセットしても再描画されないケースがあるようなので親要素側でdraw()させている
                this.$emit('redraw');
            },
            initArea() {
                const points = {
                    top_left:     {x: this.EDIT_CIRCLE_RADIUS, y: this.EDIT_CIRCLE_RADIUS},
                    top_right:    {x: this.EDIT_RECT_SIZE,     y: this.EDIT_CIRCLE_RADIUS},
                    bottom_left:  {x: this.EDIT_CIRCLE_RADIUS, y: this.EDIT_RECT_SIZE},
                    bottom_right: {x: this.EDIT_RECT_SIZE,     y: this.EDIT_RECT_SIZE},
                };
                Object.keys(points).forEach( s => this[s] = points[s] );
            },
            emitPointsInfo() {
                const {top_left, top_right, bottom_left, bottom_right} = this;
                const points = {top_left, top_right, bottom_left, bottom_right};

                this.$emit('move_end', {points: points, item: this.default_item});
            },
        }
    }
</script>

<style scoped>

</style>
